"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useCheckBoxStyles = ({ disabled, checked, label }) => {
    const theme = (0, material_1.useTheme)();
    const form = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: label ? '8px' : 'unset',
        cursor: disabled ? 'default' : 'cursor',
    };
    const checkBox = {
        width: '18px',
        height: '18px',
        borderRadius: '4px',
        border: checked ? 'hidden' : `1px solid ${theme.qlub.palette.dim.main}`,
        background: disabled
            ? theme.qlub.palette.dim.main
            : checked
                ? theme.qlub.palette.iris.main
                : theme.qlub.palette.white.main,
        '&:focus': {
            border: `1px solid ${theme.qlub.palette.iris.main}`,
            background: checked ? theme.qlub.palette.iris.main : theme.qlub.palette.white.main,
        },
        '&:hover': {
            cursor: !disabled ? 'pointer' : 'default',
            background: disabled
                ? theme.qlub.palette.dim.main
                : checked
                    ? theme.qlub.palette.iris.main
                    : theme.qlub.palette.iris_light.main,
            border: 'hidden',
        },
    };
    const icon = {
        width: '18px',
        height: '18px',
        color: `${theme.qlub.palette.white.main} !important`,
        display: 'inline-block',
        visibility: checked ? 'visible' : 'hidden',
    };
    const text = {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '146.02%',
        letterSpacing: '0.0025em',
        color: theme.qlub.palette.onSurfaceColors.highEmphasis,
    };
    return {
        checkBox,
        text,
        form,
        icon,
    };
};
exports.default = useCheckBoxStyles;
